import React from "react";
import { useNavigate } from "react-router-dom";
import { useResults, ResultRow } from "./Results";

const ResultsTeaser = () => {
  const data = useResults();
  const nav = useNavigate();
  if (!data || data.error) return null;
  const a = data.all_time, m = data.last_30d;
  return (
    <section className="res-teaser" id="results" data-testid="results-teaser">
      <div className="res-teaser-l">
        <div className="section-eye left">Track Record</div>
        <h2 className="section-h left">Receipts,<br /><em>Not Promises.</em></h2>
        <div className="res-big" data-testid="results-teaser-winrate">{a.win_rate != null ? `${a.win_rate}%` : "—"}</div>
        <div className="ac-sub">{a.win_rate != null ? `win rate over ${a.wins + a.losses} resolved signals${m.win_rate != null ? ` · ${m.win_rate}% last 30 days` : ""}` : "Results appear here as the first signals close"}</div>
        <button className="hero-cta" onClick={() => nav("/results")} data-testid="results-teaser-btn">See Every Result →</button>
      </div>
      <div className="live-card res-teaser-r">
        {data.signals.length === 0
          ? <div className="sig-wait">The scanner is live. Closed signals will be listed here.</div>
          : data.signals.slice(0, 5).map((s) => <ResultRow key={s.id} s={s} />)}
      </div>
    </section>
  );
};

export default ResultsTeaser;
